import React from 'react';
import PropTypes from 'prop-types';

import { TournamentContext, useSportState } from '@atlas/core';
import { Icon } from '@atlas/ui';

import initialTournamentShape from 'common/PropTypes/initialTournamentShape';
import Tournament from 'components/Pages/Prematch/SimplifiedTournament';

const SimplifiedFavoriteSport = ({ name, tournaments }) => {
  const { id } = useSportState();
  const { sportFormMainTypes } = tournaments[0];

  return (
    <div className="tournaments-container tournaments-container-favorites">
      <div className="menu-item-container sport favorites">
        <div className="menu-item-icon">
          <Icon alt={name} height={20} name={`sportIcon-${id}`} type="sports" width={20} />
        </div>
        <span className="menu-item-text">
          <span className="main-label">{name}</span>
        </span>
      </div>

      <div>
        {tournaments.map(tournament => (
          <TournamentContext.Provider key={tournament.id} value={tournament}>
            <Tournament sportFormMainTypes={sportFormMainTypes} tournament={tournament} />
          </TournamentContext.Provider>
        ))}
      </div>
    </div>
  );
};

SimplifiedFavoriteSport.propTypes = {
  name: PropTypes.string.isRequired,
  tournaments: PropTypes.arrayOf(initialTournamentShape).isRequired,
};

export default SimplifiedFavoriteSport;
